import { AuthAgent } from '@leapdev/auth-agent';
import { sso_login_request } from "./requests/sso_login_request";

// Authentication with LEAP requires the inclusion of the "profile" scope.
if (gon.client_id && !gon.account_not_found) {
  AuthAgent.init({
    authHost: 'https://auth.leap.services',
    clientId: gon.client_id,
    scopes: ['profile'],
  }).then((token) => {
    if (token && token !== true) {
      sso_login_request(token).then((res) => {
        window.location.href = res['redirect_url'];
      });
    }
  });
}
